import $ from 'jquery';

export function initCurriculum() {

    $(".curriculum .module,.curriculum .subject").each(function (idx_c, obj_c) {
        var $this = $(this);

        $this.find(".show-more").on("click", function (e) {
            e.preventDefault();
            $this.removeClass("closed");
        });

    });

}
